<template>
  <v-list
    v-if="selectedGroupingData.length > 0"
    class="pa-0"
  >
    <v-expansion-panels
      elevation="2"
      multiple
    >
      <v-expansion-panel
        v-for="group in selectedGroupingData"
        :key="group.alertId"
      >
        <v-expansion-panel-header>
          <v-list-item-title class="d-flex align-center">
            <v-checkbox
              :input-value="isGroupSelected(group)"
              class="pa-0 mt-2 ml-2"
              @change="onSelectionChange($event, group)"
              @click.stop
            />

            <div
              class="d-flex flex-column font-weight-medium"
              style="max-width:calc(100% - 185px); text-wrap : wrap;"
            >
              <!-- <span class=""> -->
              {{ tileTitle(group) }}
              <!-- </span> -->
              <!-- <span class="grey--text text--darken-1">{{
                tileSubTitle(group)
              }}</span> -->
            </div>

            <v-chip
              v-if="(group.ranges ? group.ranges.length : group.notifications.length) > 1"
              small
              class="mx-2"
              color="primary"
            >
              {{ group.ranges ? group.ranges.length : group.notifications.length }}
            </v-chip>
            <span class="ml-auto grey--text text--darken-1">
              {{ tileTrailingText(group) }}
            </span>
          </v-list-item-title>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <slot
            name="expansion-panel-content"
            :group="group"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-list>
</template>

<script>
export default {
  name: "BaseGroupExpansionPanels",
  props: {
    selectedGroupingData: {
      type: Array,
      required: true,
    },
    tileTitle: {
      type: Function,
      required: true,
    },
    tileSubTitle: {
      type: Function,
      required: true,
    },
    tileTrailingText: {
      type: Function,
      required: true,
    },
    onSelectionChange: {
      type: Function,
      required: true,
    },
    isGroupSelected: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedGrouping: "vessel", // New data property for grouping selection
    };
  },
  computed: {},
  methods: {},
};
</script>

  <style scoped>
.v-list-item {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 8px;
}
</style>
